import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React from 'react';

import compose from 'lib/enhancers/compose';

import pdStyles from 'components/PlanData/PlanDetails/PlanDetails.module.scss';
import RichTextWrapper from 'components/helpers/RichText/RichTextWrapper';

import styles from './PlanDetailGroupEntries.module.scss';
import { PlanDetailGroupEntriesProps } from './PlanDetailGroupEntries.Types';
import { sortPlanDetailEntries, sortPlanDetailRowEntries } from './PlanDetailGroupEntries.Functions';
import { PlanDetailEntry } from 'components/PlanData/Types/GetPlanDetailsResponse.Type';

const cx = classNames.bind(styles);
const cxPlanDetail = classNames.bind(pdStyles);

const PlanDetailGroupEntries = (props: PlanDetailGroupEntriesProps): JSX.Element => {
  // Sort the planDetailEntries based on the order specified in the PlanDetailGroupEntryOrder
  const sortedEntries = sortPlanDetailEntries(props.planDetailEntries, props.planDetailGroupEntryOrder);

  // Group the sorted Entries by their captions
  const groupedSortedEntries: { [key: string]: PlanDetailEntry[] } = {};
  sortedEntries.forEach((item) => {
    const caption = item.entryRow.entryTable?.caption?.value;
    if (caption !== undefined) {
      if (!groupedSortedEntries[caption]) {
        groupedSortedEntries[caption] = [];
      }
      groupedSortedEntries[caption].push(item);
    }
  });

  return (
    <div className={cx('plan-detail-group-entries', cxPlanDetail('container-edge'))}>
      {Object.entries(groupedSortedEntries).map(([caption, items], index) => (
        <div key={index} className={cx('group-entry-table')}>
          <h2 className={cxPlanDetail('section-header')}>{caption}</h2>
          <ol className={cx('group-entry-row')}>
            {sortPlanDetailRowEntries(items, props.planDetailRowsOrder || []).map((item, itemIndex) => (
              <React.Fragment key={itemIndex}>
                <li
                  id={'group-entry-row-header-' + item.entryRow.id}
                  className={cx('label-header', 'group-entry-column')}
                >
                  <Text field={item.entryRow.label} encode={false} />
                </li>
                <li
                  aria-describedby={'group-entry-row-header-' + item.entryRow.id}
                  className={cx('group-entry-column')}
                >
                  <RichTextWrapper field={{ value: item.description?.value?.toString() }} />
                </li>
              </React.Fragment>
            ))}
          </ol>
        </div>
      ))}
    </div>
  );
};

export default compose<PlanDetailGroupEntriesProps>()(PlanDetailGroupEntries);
